import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function JSDisplay({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"default"} value={""}>
          Default
        </MenuItem>,
        <MenuItem key={"none"} value={"none"}>
          none (Will show up as transparent in live editor so it is still selectable. Is actually gone in live)
        </MenuItem>,
        <MenuItem key={"none"} value={"block"}>
          block
        </MenuItem>,
        <MenuItem key={"flex"} value={"flex"}>
          flex
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSDisplayComponent: JSInputComponent = {
  Component: JSDisplay,
  handlesCssProperties: ["display"],
};
